import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { FiltroDto } from '../dto/util/filtro-dto';
import { AlertaFiltroDto } from '../dto/alerta/alerta.filtro.dto';
import { Observable } from 'rxjs';
import { PaginaDto } from '../dto/util/pagina-dto';
import { AlertaDto } from '../dto/alerta/alerta.dto';
import { TipoAlertaDto } from '../dto/alerta/tipo-alerta.dto';

@Injectable({
  providedIn: 'root',
})
export class AlertaService {
  private apiUrl = `${environment.apiUrl}/alerta`;

  constructor(private http: HttpClient) {}

  filtrar(
    filtro: FiltroDto<AlertaFiltroDto>
  ): Observable<PaginaDto<AlertaDto>> {
    return this.http.post<PaginaDto<AlertaDto>>(
      `${this.apiUrl}/filtrar`,
      filtro
    );
  }

  cambiarEstadoLeido(id: number): Observable<AlertaDto> {
    return this.http.put<AlertaDto>(`${this.apiUrl}/cambiarEstadoLeido`, {
      id: id,
    });
  }

  cambiarEstadoArchivado(id: number): Observable<AlertaDto> {
    return this.http.put<AlertaDto>(`${this.apiUrl}/cambiarEstadoArchivado`, {
      id: id,
    });
  }

  cambiarEstadoPrioritario(id: number): Observable<AlertaDto> {
    return this.http.put<AlertaDto>(`${this.apiUrl}/cambiarEstadoPrioritario`, {
      id: id,
    });
  }

  contarPorFiltro(filtro: AlertaFiltroDto) {
    return this.http.post<number>(`${this.apiUrl}/contarPorFiltro`, filtro);
  }

  marcarLeidoPorFiltro(filtro: AlertaFiltroDto) {
    return this.http.put<number>(`${this.apiUrl}/marcarLeidoPorFiltro`, filtro);
  }

  obtenerTodasLasAlertas(): Observable<{ data: TipoAlertaDto[] }> {
    return this.http.get<{ data: TipoAlertaDto[] }>(`${this.apiUrl}/todas`);
  }

  actualizarAlerta(alerta: {
    Id: number;
    Descripcion: string;
  }): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/${alerta.Id}`, alerta);
  }
}
